export const Stack = ({ children }: { children: React.ReactNode }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "var(--padding-100)", alignItems: "center" }}>
    {children}
  </div>
);